import { render, staticRenderFns } from "./ExpandableVulnSection.vue?vue&type=template&id=63360908&scoped=true"
import script from "./ExpandableVulnSection.vue?vue&type=script&lang=js"
export * from "./ExpandableVulnSection.vue?vue&type=script&lang=js"
import style0 from "./ExpandableVulnSection.vue?vue&type=style&index=0&id=63360908&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63360908",
  null
  
)

export default component.exports